import { UserRoleViewPermissions, AssignedPermissions, ViewPermissions } from '../constants/permissions';

// Pure function: compute permissions from roles + patient assignment context
// This is the core logic extracted from usePermissions hook for testability
export const computePermissions = ({ roles, authId, assignedStaff }) => {
  const result = new Set();

  // Get permissions from user roles
  if (roles) {
    roles.forEach(role => {
      const rolePermissions = UserRoleViewPermissions[role] || [];
      rolePermissions.forEach(perm => result.add(perm));
    });
  }

  // Merge assigned staff permissions (when viewing a specific patient)
  if (authId && assignedStaff) {
    assignedStaff.forEach(el => {
      if (el.staffId === authId) {
        if (Array.isArray(AssignedPermissions[el.role])) {
          AssignedPermissions[el.role].forEach(perm => result.add(perm));
        }
      }
    });
  }

  return [...result];
};

export const hasViewReportPermission = (userPermissions) => {
  return userPermissions.includes(ViewPermissions.VIEW_REPORT_UNLOCKED)
    || userPermissions.includes(ViewPermissions.VIEW_REPORT_LOCKED);
};
